
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { isAuthenticated as checkIsAuthenticated } from '../../components/admin/isAuthenticated';
import OrganisationScenarios from '../../components/organisation/Scenarios';


function OrgDashboard() {
    const [organisationId, setOrganisationId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOrgId = async () => {
            const result = await checkIsAuthenticated();
            if (result && result.status && result.organisationId) {
                setOrganisationId(result.organisationId);
            }
            setLoading(false);
        };
        fetchOrgId();
    }, []);

    if (loading) return null;

    return (
        <div>
            <Container>
                <br />
                <h1 className='orange-color-font font-family-ProximaNova'>
                    <b>Organisation Dashboard</b>
                </h1>
                <br />
                <h4 className='font-family-RalewayExtraBold'>My Scenarios</h4>
                <hr />
                <OrganisationScenarios organisationId={organisationId} />
            </Container>
        </div>
    );
}

export default OrgDashboard;
